import { useQuery } from 'react-query';
import { getEmailTemplateDefaults } from '../../api/getEmailTemplateDefaults';

export const useGetEmailTemplateDefaults = () => {
  return useQuery('emailTempateDefaults', () => getEmailTemplateDefaults(), {
    refetchOnWindowFocus: false,
  });
};
